export default "__VITE_ASSET__BZqiwf69__"